<template>
  <Comp_CompetitionAdd></Comp_CompetitionAdd>
</template>

<script>
import Comp_CompetitionAdd from '../components/AddCompetition.vue';

export default {
  name: 'Competition',
  components: {
    Comp_CompetitionAdd
  },
};
</script>